const testimonials = [
  {
    quote:
      "Jay is the first coach who asked me how I was sleeping before asking about my macros. That single shift changed how I train.",
    name: "Priya M.",
    role: "Mind & Body Reset alum",
  },
  {
    quote:
      "I finished Sunrise Strength stronger than I've ever been — and somehow less anxious. Didn't expect the second part.",
    name: "Marcus T.",
    role: "Sunrise Strength · Cohort 3",
  },
  {
    quote:
      "The nutrition program worked because it didn't feel like a diet. I just learned. My grocery cart has changed forever.",
    name: "Danielle R.",
    role: "Nutrition Foundations grad",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12 bg-[#F7F5F0] border-y border-[#E5E2D9] relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-16 md:mb-20 max-w-2xl">
          <div className="overline mb-4">Kind Words</div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight leading-[1.05] text-[#2D372B]">
            From the people
            <br />
            <span className="italic text-[#AD6A48]">actually doing the work.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="bg-white/80 border border-[#E5E2D9] rounded-3xl p-8 backdrop-blur-sm hover:bg-white transition-colors"
            >
              <blockquote className="font-serif-display text-xl md:text-2xl leading-snug italic text-[#2D372B]/85 mb-8">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="pt-6 border-t border-[#E5E2D9]">
                <div className="text-[#2D372B] font-medium">{t.name}</div>
                <div className="text-sm text-[#5C665A]">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
